module.exports = __webpack_public_path__ + "static/media/BIMpic10.93cd54cb.png";